import React, { useState } from 'react';
import { Mail, Phone, MapPin, Clock, Send, MessageSquareCode, Sparkles } from 'lucide-react';
import './ContactUs.css';

export default function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email || !subject || !message) {
      alert("Please fill in all fields.");
      return;
    }

    // Mock send request
    setIsSent(true);
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');

    setTimeout(() => setIsSent(false), 6000);
  };

  const contactDetails = [
    {
      icon: <Phone size={24} />,
      title: 'Call Us',
      lines: ['+91 77948 90990', '+91 92962 06555'],
      color: 'primary'
    },
    {
      icon: <Mail size={24} />,
      title: 'Email Us',
      lines: ['holidaykartofficial@gmail.com'],
      color: 'accent'
    },
    {
      icon: <MapPin size={24} />,
      title: 'Our Office',
      lines: ['Hyderabad', 'Telangana, India'],
      color: 'gold'
    },
    {
      icon: <Clock size={24} />,
      title: 'Working Hours',
      lines: ['Mon - Sat: 9:00 AM - 7:00 PM', 'Sunday: Closed'],
      color: 'success'
    }
  ];

  return (
    <div className="contact-page container section">
      <div className="section-title">
        <h2>Get in Touch</h2>
        <p>Have questions about a destination? Need a customized package? Our expert curators are here to help.</p>
      </div>

      <div className="contact-layout">
        {/* Contact Info Sidebar */}
        <div className="contact-info-column">
          <div className="grid grid-2 info-grid">
            {contactDetails.map((detail, idx) => (
              <div key={idx} className="info-card glass-card">
                <div className={`info-icon-wrapper icon-${detail.color}`}>
                  {detail.icon}
                </div>
                <h3>{detail.title}</h3>
                {detail.lines.map((line, lidx) => (
                  <p key={lidx}>{line}</p>
                ))}
              </div>
            ))}
          </div>

          {/* Interactive Map Card */}
          <div className="map-card glass-card">
            <div className="map-mockup">
              <div className="map-radar"></div>
              <div className="map-pin-marker">
                <MapPin size={32} className="pin-icon" />
                <div className="pulse-ring"></div>
              </div>
              <div className="map-tooltip">
                <strong>Holiday Kart Headquarters</strong>
                <span>Hitech City </span>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form Area */}
        <div className="contact-form-column glass-card">
          <div className="form-header">
            <MessageSquareCode size={24} className="form-header-icon" />
            <h3>Send Us a Message</h3>
          </div>

          {isSent ? (
            <div className="form-success-message">
              <Sparkles size={48} className="success-icon" />
              <h3>Message Sent Successfully!</h3>
              <p>Thank you for reaching out. A travel specialist from our desk will reply to your email shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-main-form">
              <div className="form-group">
                <label className="form-label">Your Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Subject</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="What is this regarding?"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  placeholder="Write your detailed inquiry here..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary contact-submit-btn">
                <Send size={16} />
                <span>Send Message</span>
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
